import React from 'react';
import CommonLayout from './CommonLayout';
import { useReservations } from '../../hooks/collections/useReservations';
import { useUserSessionStore } from '../../stores/UserSession.store';
import { UserTypeEnum } from '../../@core/enums/UserType.enum';
import { IReservation } from '../../@core/interfaces/IReservation';
import { BadgeOrder } from '../../components/OrderStatus/BadgeOrder';
import ButtonSecondary from '../../shared/Button/ButtonSecondary';
import { NotFound } from '../../components/NotFound/NotFound';
import { useNavigate } from 'react-router-dom';
import { Collections } from '../../@core/constants/FirebasePaths';
import { IQuery, useFirebaseData } from '../../@shared/hooks/useFirebaseData';

const AccountReservations = () => {
  const user = useUserSessionStore((state) => state.user);
  const db = useFirebaseData({ collectionPath: null, loadData: false });
  const { reservations } = useReservations({
    loadData: true,
    queries: [
      ...(user?.role === UserTypeEnum.COMPANY ? [{
        type: 'where',
        field: 'service.company.id',
        operator: '==',
        value: user.id
      }] : []),
      ...(user?.role === UserTypeEnum.PROVIDER ? [{
        type: 'where',
        field: 'service.details.provider.id',
        operator: '==',
        value: user.id
      }] : []),
      ...(user?.role === UserTypeEnum.USER ? [{
        type: 'where',
        field: 'createdBy',
        operator: '==',
        value: db.getReference(`${Collections.users._path}/${user.id}`)
      }] : []),
      { type: 'orderBy', field: 'createdAt', direction: 'desc' }
    ] as IQuery[]
  });
  const navigate = useNavigate();

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div>
          <h2 className="text-3xl font-semibold">My reservations</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className={'overflow-x-auto'}>
          {reservations.length ? (
            <table className={'w-full text-left min-w-[1000px] border-separate border-spacing-4'}>
              <thead>
              <tr>
                <th>Service</th>
                <th>Status</th>
                <th>Day</th>
                <th>Hour</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {reservations?.map((reservation: IReservation) => (
                <tr key={reservation.id}>
                  <td>{reservation.service?.title}</td>
                  <td><BadgeOrder status={reservation.paymentStatus}/></td>
                  <td>{reservation.day}</td>
                  <td>{reservation.hour}</td>
                  <td>
                    <ButtonSecondary onClick={() => navigate(`/reservation-detail/${reservation.id}`)}>View
                      Details</ButtonSecondary>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          ) : (
            <NotFound description={'No orders found from you.'}/>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountReservations;
